import React from "react";
import PropTypes from "prop-types";

/**
 * Componente SmallCard
 *
 * @component
 * @param {Object} props - As propriedades do componente.
 * @param {string} props.title - O título a ser exibido no card.
 * @param {string|number} props.value - O valor a ser exibido no card.
 * @param {string} props.icon - O ícone a ser exibido no card.
 * @returns {ReactElement} O elemento React renderizado que representa o card.
 */
function SmallCard({ title, value, icon }) {
  return (
    <div className="col-md-4">
      <div className="card mini-stats-wid">
        <div className="card-body contasspg-driver">
          <div className="media">
            <div className="media-body">
              <p className="text-muted fw-medium mb-2">{title}</p>
              <h4 className="mb-0">{value}</h4>
            </div>
            <div className="mini-stat-icon avatar-sm align-self-center rounded-circle bg-primary">
              <span className="avatar-title  color-orange">
                <i className={`${icon} font-size-24`}></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SmallCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.string.isRequired,
};

export default SmallCard;
